import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token && token.trim()) {
    config.headers.Authorization = `Bearer ${token.trim()}`;
  }
  return config;
});

api.interceptors.request.use((config) => {
  try {
    const userProfile = JSON.parse(localStorage.getItem("userProfile") || "{}");
    const fullName =
      `${userProfile.Fname || ""} ${userProfile.Lname || ""}`.trim();

    config.headers["X-User-FullName"] = fullName || "Unknown User";
  } catch (err) {
    config.headers["X-User-FullName"] = "Unknown User";
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 ||
        (error.response.status === 403 &&
          (error.response.data?.message === "Invalid or expired token" ||
            error.response.data?.message === "Token has been revoked" ||
            error.response.data?.code === "TENANT_REQUIRED")))
    ) {
      if (localStorage.getItem("token")) {
        localStorage.removeItem("token");
        localStorage.removeItem("userProfile");
        localStorage.removeItem("username");
      }
    }
    return Promise.reject(error);
  }
);

export const loginUser = async (identifier, password) => {
  const res = await api.post("/auth/login", {
    identifier,
    password,
  });
  return res.data;
};

export const googleLoginUser = async (credential) => {
  const res = await api.post("/auth/google-login", {
    credential,
  });

  return res.data;
};

export const registerUser = async (username, password) => {
  try {
    const res = await api.post("/auth/register", { username, password });
    return res.data;
  } catch (err) {
    throw err.response?.data || err;
  }
};

export const logoutUser = async () => {
  try {
    const token = localStorage.getItem("token");
    await api.post(
      "/auth/logout",
      {},
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );
  } catch (err) {
    console.error("Logout error:", err);
  } finally {
    localStorage.clear();
  }
};

export const forgotPassword = async (email) => {
  const res = await api.post("/auth/forgot-password", { email });
  return res.data;
};

export const verifyResetOtp = async (email, otp) => {
  const res = await api.post("/auth/verify-reset-otp", { email, otp });
  return res.data;
};

export const resetPassword = async (email, otp, password) => {
  const res = await api.post("/auth/reset-password", { email, otp, password });
  return res.data;
};

export default api;
